import './Table.scss';

export const Table = ({requireColumns = [], additionalColumns = [], clientColumns = [], data, renderCell, onRowClick}) => {

    const trimText = (text, maxLength) => {
        if (typeof text !== "string") {
            return text;
        }

        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    }

    return (
        <div className={"table"}>
            <table className={"table_container"}>
                <thead className={"table_header"}>
                    <tr className={"table_header-row"}>
                        {requireColumns.map((column, index) => (
                            <th className={"table_header-cell"} key={`left-${index}`}>
                                {column.header}
                            </th>
                        ))}
                        {clientColumns.map((column, index) => (
                            <th className={"table_header-cell"} key={`middle-${index}`}>
                                {column.header}
                            </th>
                        ))}
                        {additionalColumns.map((column, index) => (
                            <th className={"table_header-cell"} key={`right-${index}`}>
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className={"table_body"}>
                {data.map((row, rowIndex) => (
                    <tr className={"table_body-row"} key={rowIndex} onClick={() => onRowClick?.(row, rowIndex)}>
                        {requireColumns.map((column, index) => (
                            <td className={"table_body-cell"} key={`left-${rowIndex}-${index}`}>
                                {trimText(row[column.key], 30)}
                            </td>
                        ))}
                        {clientColumns.map((column, index) => (
                            <td className={"table_body-cell"} key={`middle-${rowIndex}-${index}`}>
                                {trimText(row[column.key], 30)}
                            </td>
                        ))}
                        {additionalColumns.map((column, index) => (
                            <td className={"table_body-cell"} key={`right-${rowIndex}-${index}`}>
                                {renderCell ? renderCell(column.key, row[column.key], row) : trimText(row[column.key], 30)}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}